import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCampaigns } from '../services/api';
import { format } from 'date-fns';

function CampaignList() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const data = await getCampaigns();
      setCampaigns(data.campaigns || []);
      setError(null);
    } catch (err) {
      setError('Failed to load campaigns');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCampaignClick = (id) => {
    navigate(`/campaigns/${id}`);
  };

  if (loading) {
    return <div className="loading">Loading campaigns...</div>;
  }

  return (
    <div className="campaign-list-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h1>All Campaigns</h1>
        <button
          className="button button-primary"
          onClick={() => navigate('/campaigns/new')}
        >
          Create New Campaign
        </button>
      </div>

      {error && <div className="error">{error}</div>}

      {campaigns.length === 0 ? (
        <div className="card">
          <p>No campaigns yet. Create your first campaign to get started!</p>
        </div>
      ) : (
        <ul className="campaign-list">
          {campaigns.map(campaign => (
            <li
              key={campaign.campaign_id}
              className="campaign-item"
              onClick={() => handleCampaignClick(campaign.campaign_id)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                  <h3>{campaign.name}</h3>
                  <p style={{ color: '#666', margin: '0.5rem 0' }}>{campaign.subject}</p>
                  <div className="meta">
                    <span className={`status-badge status-${campaign.status}`}>
                      {campaign.status}
                    </span>
                    <span style={{ marginLeft: '1rem' }}>
                      Created: {format(new Date(campaign.created_at * 1000), 'MMM dd, yyyy')}
                    </span>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#333' }}>
                    {campaign.sent_count || 0} / {campaign.total_recipients || 0}
                  </div>
                  <div style={{ color: '#666', fontSize: '0.875rem' }}>emails sent</div>
                  {campaign.sent_count > 0 && (
                    <div style={{ marginTop: '0.5rem', color: '#0066cc' }}>
                      {((campaign.open_count || 0) / campaign.sent_count * 100).toFixed(1)}% open rate
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CampaignList;
